import { Box, Text } from "@mantine/core"

import { Label } from "../../atoms/Label/Label"
import { LabelWithTooltip } from "../LabelWithTooltip/LabelWithTooltip"
import { Loader } from "../Loader/Loader"

export type BuildLabelProps = {
  label: React.ReactNode
  isLoading?: boolean
  required?: boolean
  toolTip?: string
}
export const buildLabel = ({
  label,
  isLoading,
  required,
  toolTip,
}: BuildLabelProps) => {
  const hasTooltipLabel = toolTip && typeof label === "string"
  const labelNode = hasTooltipLabel ? (
    <LabelWithTooltip label={label} hoverHelperText={toolTip} size="sm" />
  ) : (
    label
  )

  if (!isLoading && !required) {
    if (hasTooltipLabel) return labelNode
    return <Label label={label} size="sm" />
  }

  return (
    <Box display="flex">
      {labelNode}
      {required && (
        <Text span c="var(--mantine-color-error)">
          *
        </Text>
      )}
      {isLoading && <Loader type="oval" size="xs" ml="xs" />}
    </Box>
  )
}
